/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

const BROADPEAK_ERROR_BASE = 0x0a00;

/**
 * Collection of fl-ads-broadpeak error codes.
 */
export const BroadpeakErrorCodes = Object.freeze({
  /**
   * Indicates that the Broadpeak SmartLib instance is not initialized.
   */
  SMARTLIB_INSTANCE_NOT_INITIALIZED: BROADPEAK_ERROR_BASE + 0x01,

  /**
   * Indicates that Broadpeak getURL() failed.
   */
  GET_URL_FAILURE: BROADPEAK_ERROR_BASE + 0x02,

  /**
   * Indicates that the initialization URL is invalid.
   */
  INVALID_INITIALIZATION_URL: BROADPEAK_ERROR_BASE + 0x03,
});
